// Runs the first QuickBooks sync right after the owner connects.
//
// Why this exists: Intuit sends the owner back to the app with ?qb_connected=true. App.js cleans that
// address (history.replaceState) in its first effect, and only afterwards, in async code, looks for it
// again, so the check never sees it and no first sync ran.
//
// How: the flag is read ONCE, while the first render is happening, which is before any effect (and so
// before the address is cleaned). When a signed-in business id is available, the sync starts, once.
// It does nothing in the demo and never runs twice.

import { useEffect, useRef } from 'react';

// True when the address says the owner just came back from connecting QuickBooks.
export function cameBackFromConnect(search) {
  try { return new URLSearchParams(search || '').get('qb_connected') === 'true'; } catch { return false; }
}

export function useFirstSyncAfterConnect({ demo, userId, triggerSync }) {
  const cameBack = useRef(null);
  if (cameBack.current === null) cameBack.current = !demo && cameBackFromConnect(window.location.search);
  const done = useRef(false);
  const latest = useRef(triggerSync);
  latest.current = triggerSync;

  useEffect(() => {
    if (demo || !userId || !cameBack.current || done.current) return;
    done.current = true;
    latest.current(userId);
  }, [demo, userId]);
}
